module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-105.687b5297.svg";